/**
 * "Add to CNB Payout Run" on the producer payout index.
 *
 * Tick payouts, open the modal, and either start a run or add them to one that
 * has not been exported yet. Every number and every refusal in the modal comes
 * from the preview endpoint rather than being recomputed here — the rules about
 * who is onboarded and what is already claimed live server-side, and a second
 * copy in the browser would eventually disagree with the one that decides.
 *
 * Requires card-modals.js (window.CardModal), loaded earlier in the bundle.
 */
(function () {
  'use strict';

  var trigger = document.getElementById('cnb-run-add');
  var modal = document.getElementById('cnb-run-modal');
  if (!trigger || !modal) return;

  var API = '/tools/payments-admin/api';
  var body = document.getElementById('cnb-run-modal-body');
  var confirmBtn = document.getElementById('cnb-run-confirm');
  var preview = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function usd(cents) {
    return '$' + (Number(cents || 0) / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }
  function post(path, payload) {
    return fetch(API + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (d) { return { ok: r.ok, d: d }; });
    });
  }

  function selectedIds() {
    return Array.prototype.map.call(
      document.querySelectorAll('input.check_index.row_id:checked'),
      function (cb) { return Number(cb.value); }
    ).filter(Boolean);
  }

  // The trigger reads as unavailable until something is ticked, rather than
  // opening a modal that can only say "select at least one payout".
  function syncTrigger() {
    var n = selectedIds().length;
    trigger.setAttribute('aria-disabled', n ? 'false' : 'true');
    trigger.classList.toggle('disabled', !n);
  }

  // Plain labelled radios in a flex column — no list markup, so this needs no
  // stylesheet of its own beyond the utility classes the theme already ships.
  function radioRow(id, label, note) {
    return '<div class="d-flex align-center gap-2">' +
      '<label><input type="radio" name="cnb-run-target" value="' + esc(id) + '"> ' +
      '<b>' + label + '</b></label>' + (note ? '<span class="text-muted">' + note + '</span>' : '') +
      '</div>';
  }

  function blockedTable(rows) {
    if (!rows.length) return '';
    return '<div class="callout alert">' +
      '<p><b>' + rows.length + ' selected payout' + (rows.length === 1 ? '' : 's') +
      ' cannot go into a run.</b> They stay as they are; the rest still go in.</p>' +
      '<table class="table"><thead><tr><th>Payout</th><th>Payee</th>' +
      '<th class="text-right">Amount</th><th>Why not</th></tr></thead><tbody>' +
      rows.map(function (r) {
        return '<tr><td>#' + r.id + ' <span class="text-muted">' + esc(r.date || '') + '</span></td>' +
          '<td>' + esc(r.payee) + '</td>' +
          '<td class="text-right">' + usd(r.amount_cents) + '</td>' +
          '<td>' + esc(r.reason) + '</td></tr>';
      }).join('') +
      '</tbody></table></div>';
  }

  function render() {
    var eligible = preview.eligible || [];
    var open = preview.open_runs || [];

    if (!eligible.length) {
      body.innerHTML = blockedTable(preview.blocked || []) +
        '<p class="text-muted">Nothing in this selection can be added to a run.</p>';
      confirmBtn.disabled = true;
      return;
    }

    var choices = radioRow('new', 'New payout run',
      esc(preview.suggested_label)) +
      open.map(function (r) {
        return radioRow(r.id, esc(r.label || ('Run #' + r.id)),
          usd(r.total_cents) + ' owed · <a href="' + esc(r.payouts_url) +
          '" target="_blank" rel="noopener">show associated payouts</a>');
      }).join('');

    body.innerHTML =
      '<p><b>' + eligible.length + ' payout' +
      (eligible.length === 1 ? '' : 's') + '</b> totalling <b>' + usd(preview.total_cents) +
      '</b> will be added.</p>' +
      blockedTable(preview.blocked || []) +
      '<div class="d-flex flex-column gap-2">' + choices + '</div>';

    // Default to a new run: it is the only choice that is always correct.
    var first = body.querySelector('input[name="cnb-run-target"]');
    if (first) first.checked = true;
    confirmBtn.disabled = false;
  }

  function open() {
    var ids = selectedIds();
    if (!ids.length) return;
    body.innerHTML = '<p class="text-muted">Checking the selected payouts…</p>';
    confirmBtn.disabled = true;
    window.CardModal.open('cnb-run-modal');
    post('/runs/from-payouts/preview', { payout_ids: ids }).then(function (res) {
      if (!res.ok) {
        body.innerHTML = '<div class="callout alert">' +
          esc((res.d && res.d.error) || 'Could not read the selected payouts.') + '</div>';
        return;
      }
      preview = res.d;
      render();
    });
  }

  function submit() {
    var picked = body.querySelector('input[name="cnb-run-target"]:checked');
    if (!picked) return;
    var payload = { payout_ids: (preview.eligible || []).map(function (r) { return r.id; }) };
    if (picked.value !== 'new') payload.run_id = Number(picked.value);

    confirmBtn.disabled = true;
    post('/runs/from-payouts', payload).then(function (res) {
      if (!res.ok) {
        body.innerHTML = '<div class="callout alert">' +
          esc((res.d && res.d.error) || 'Could not add these payouts to a run.') + '</div>';
        confirmBtn.disabled = false;
        return;
      }
      // The run opens in its own tab and this page reloads: the statuses of every
      // row just changed, and a stale index that still says New is how a payout
      // gets added to a second run.
      window.open('/tools/payments-admin#runs/' + res.d.run.id, '_blank', 'noopener');
      window.location.reload();
    });
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    open();
  });
  confirmBtn.addEventListener('click', submit);
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('check_index')) syncTrigger();
  });
  // check_all_index ticks every row without firing a change event per row.
  document.addEventListener('click', function (e) {
    if (e.target.classList && e.target.classList.contains('check_all_index')) {
      setTimeout(syncTrigger, 0);
    }
  });

  syncTrigger();
})();
